import React from 'react';

import ManualItems from './ManualItems';
import AutoItems from './AutoItems';

import Radios from '../../../common/Radios';

const radiosData = [
  {
    label: 'Ручное',
    value: 'MANUAL',
    description: 'При ручном заполнении товары добавляются из общего списка',
  },
  {
    label: 'Автоматическое',
    value: 'AUTO',
    description: 'При автоматическом заполняются по заданным правилам',
  },
];

const CollectionFilling = (props) => {
  const {
    isNew,
    collection,
    fillType,
    currentProducts,
    logicMode,
    filters,
    handleSetFillType,
    handleUpdateProducts,
    handleUpdateFiltersLogicMode,
    handleUpdateFilters,
  } = props;

  const blockTitle =
    isNew || !collection
      ? 'Способ наполнения'
      : `Тип коллекции: ${collection.fillType === 'MANUAL' ? 'ручная' : 'автоматическая'}`;

  return (
    <div className="card-box">
      <div className="row">
        <div className="col-12">
          <h4 className="header-title">{blockTitle}</h4>
        </div>
      </div>
      {isNew ? (
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Radios
                id="fillingType"
                name="fillingType"
                data={radiosData}
                currentValue={fillType}
                onChange={handleSetFillType}
              />
            </div>
          </div>
        </div>
      ) : null}
      <div className="row" style={{ marginBottom: '15px', marginTop: '10px' }}>
        <div className="col-12">
          <h4 className="header-title">{fillType === 'MANUAL' ? 'Товары' : 'Условия'}</h4>
        </div>
      </div>

      {fillType === 'MANUAL' ? (
        <ManualItems
          currentProducts={currentProducts}
          handleUpdateProducts={handleUpdateProducts}
        />
      ) : (
        <AutoItems
          logicMode={logicMode}
          filters={filters}
          handleUpdateFiltersLogicMode={handleUpdateFiltersLogicMode}
          handleUpdateFilters={handleUpdateFilters}
        />
      )}
    </div>
  );
};

export default CollectionFilling;
